import { apiRequest, apiFileUploadRequest } from '../apiRequest';
import { 
  UPLOAD_DOCUMENT_ENDPOINT, 
} from '../urls';

export const uploadDocument = (data, requestId) => {
  return apiFileUploadRequest('POST', `${UPLOAD_DOCUMENT_ENDPOINT}/${requestId}`, data);
}

